import BaseComponent from '@/components/base';
import cartNoticeStyle from '@/components/cart-notice/style';
import Events from '@/components/cart-notice/events';

export default class CartNotice extends BaseComponent {
  render() {
    return `
       ${cartNoticeStyle}
      <div class="container">
        <span class="handle"></span>
        <div class="title">Added to Cart</div>
        <div class="msg">Your custom products have been added to your cart.</div>
        <div class="actions">
          <button class="button continue" id="continue-btn">Continue Shopping</button>
          <button class="button view" id="view-cart-btn">View Cart</button>
        </div>
      </div>
    `;
  }

  afterMount() {
    this.continueBtn?.addEventListener('click', () => {
      this.dispatchEvent(
        new CustomEvent(Events.ContinueShopping, {
          bubbles: true,
          composed: true
        })
      );
    });
    this.viewCartBtn?.addEventListener('click', () => {
      this.dispatchEvent(
        new CustomEvent(Events.ViewCart, { bubbles: true, composed: true })
      );
    });
  }

  show() {
    this.container.style.transition =
      'transform 0.5s cubic-bezier(0.4,0,0.2,1), opacity 0.5s cubic-bezier(0.4,0,0.2,1)';
    this.container.style.visibility = 'visible';
    this.container.style.transform = 'translateY(0)';
    this.container.style.opacity = 1;
    // Animate from bottom to middle
    this.container.style.top = '50%';
    this.container.style.bottom = 'auto';
    this.container.style.transform = 'translateY(-50%)';
    this.scrollToTop();
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  hide() {
    this.container.style.transition =
      'transform 0.5s cubic-bezier(0.4,0,0.2,1), opacity 0.5s cubic-bezier(0.4,0,0.2,1)';
    // Animate back to bottom
    this.container.style.transform = 'translateY(100%)';
    this.container.style.opacity = 0;
    this.container.style.top = '';
    this.container.style.bottom = '0';

    setTimeout(() => {
      this.container.style.visibility = 'hidden';
    }, 500);
  }
  get container() {
    return this.shadowRoot.querySelector('.container');
  }
  get continueBtn() {
    return this.shadowRoot.getElementById('continue-btn');
  }
  get viewCartBtn() {
    return this.shadowRoot.getElementById('view-cart-btn');
  }
}
